module.exports = __webpack_public_path__ + "img/parts1.e369be52.png";